import React from 'react';
import StudentTraineeLetterComp from './StudentTraineeLetterComp';

function StudentTraineeLetter() {
  return <StudentTraineeLetterComp />;
}

export default StudentTraineeLetter;
